import { createColumnHelper } from "@tanstack/react-table";
import actionIcon from "assets/svg/action.svg";
import deleteIcon from "assets/svg/delete.svg";
import plusIcon from "assets/svg/plus-icon.svg";
import DataTable from "components/datatable/datatable";
import Loader from "components/loader";
import { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { convertToDDMMYYYYWithTime, stripHtmlTags } from "utils/utils";
import { deleteAnnoucement, getAllAnnouncement } from "../../../axios/api";
import Modal from "react-modal";
import "./style.css";

const Announcement = () => {
  const navigate = useNavigate();
  const [searchField, setSearchField] = useState("");

  const [filter, setFilter] = useState({
    page: 1,
    limit: 10,
    filter: {},
  });
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [announcementData, setAnnouncementData] = useState<any>();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [deleteId, setDeleteId] = useState<string | null>(null);
  const columnHelper = createColumnHelper<any>();

  const columns: any = [
    columnHelper.accessor("title", {
      id: "title",
      header: () => (
        <p className="text-base font-normal text-[#424242] dark:text-white">
          Announcement
        </p>
      ),
      cell: (info) => (
        <div className="flex items-center">
          <p className="ml-3 flex items-center  text-sm font-bold text-navy-700 dark:text-white">
            {info && info?.row?.original?.image ? (
              <img
                src={info.row.original?.image}
                alt="cover"
                className="me-3 w-8"
              />
            ) : null}
            {stripHtmlTags(info.getValue())}
          </p>
        </div>
      ),
    }),
    columnHelper.accessor("createdAt", {
      id: "createdAt",
      header: () => (
        <div className="flex items-center justify-center">
          <p className="text-base font-normal text-[#424242] dark:text-white">
            Created Date
          </p>
        </div>
      ),
      cell: (info) => (
        <p className=" flex max-h-5  w-full justify-center overflow-hidden dark:text-white">
          <div className="max-w-[20%] dark:text-white" />
          {convertToDDMMYYYYWithTime(
            info.getValue().slice(0, 10) + " " + info.getValue().slice(11, 19)
          )}
        </p>
      ),
    }),
    columnHelper.accessor("expiry_date", {
      id: "expiry_date",
      header: () => (
        <div className="flex items-center justify-center">
          <p className="text-base font-normal text-[#424242] dark:text-white">
            Expiry Date
          </p>
        </div>
      ),
      cell: (info) => (
        <p className=" flex max-h-5  w-full justify-center overflow-hidden dark:text-white">
          <div className="max-w-[20%] dark:text-white" />
          {convertToDDMMYYYYWithTime(
            info.getValue()?.slice(0, 10) + " " + info.getValue()?.slice(11, 19)
          )}
        </p>
      ),
    }),
    columnHelper.accessor("id", {
      id: "id",
      header: () => (
        <p className="px-[3rem] text-base font-normal text-[#424242] dark:text-white">
          Action
        </p>
      ),
      cell: (info) => (
        <div className="flex gap-2">
          <button
            type="button"
            onClick={() =>
              navigate(`/admin/announcement/edit`, { state: info.getValue() })
            }
            className="text-black me-2 inline-flex items-center rounded-lg border-4 px-3 py-2.5 text-center text-sm font-medium hover:bg-[#0098DA] hover:text-white focus:outline-none focus:ring-4 focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
          >
            <img
              src={actionIcon}
              alt="action-icon"
              className="w-4.1 me-2 h-5"
            />
            Edit
          </button>
          <button
            onClick={() => openModal(info.row.original.id)}
            type="button"
            className="text-black me-2 inline-flex items-center rounded-lg border-4 px-3 py-2.5 text-center text-sm font-medium hover:bg-[#0098DA] hover:text-white focus:outline-none focus:ring-4 focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
          >
            <img
              src={deleteIcon}
              alt="delete-icon"
              className="w-4c.1 me-2 h-5"
            />
            Delete
          </button>
        </div>
      ),
    }),
  ];

  useEffect(() => {
    const fetchAnnouncement = async () => {
      try {
        setLoading(true);
        const announcementDataResp = await getAllAnnouncement(
          filter.page,
          filter.limit
        );
        setAnnouncementData(announcementDataResp?.data?.data?.announcements);
        setTotalCount(announcementDataResp?.data?.data?.totalResults);
        if (!announcementDataResp?.data?.success) {
          toast.error("Error Fetcing Announcements");
          console.log("announcementDataResp", announcementDataResp);
        }
      } catch (error) {
        toast.error("Error Fetcing Announcements");
        console.log("error", error);
      } finally {
        setLoading(false);
      }
    };
    fetchAnnouncement();
  }, [filter]);

  const onPageChange = ({ selected }: any) => {
    setFilter((prevFilter) => ({
      ...prevFilter,
      page: selected + 1,
    }));
  };

  const openModal = (id: string) => {
    setDeleteId(id);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setDeleteId(null);
  };

  const handleDelete = async () => {
    if (deleteId) {
      try {
        await deleteAnnoucement(deleteId);
        toast.success("Annoucement deleted successfully");
        setFilter((prev) => ({ ...prev, page: 1 }));
      } catch (error) {
        toast.error("Error deleting Announcement");
      } finally {
        closeModal();
      }
    }
  };

  return (
    <>
      {loading && <Loader />}
      <div className="h-full rounded-md bg-white">
        <div className="flex justify-between p-4">
          <span className="text-2xl font-bold">Announcements</span>
          <div className="relative ml-[5rem]">
            {/* <img
              src={searchIcon}
              className="absolute left-3 top-[10px]"
              alt="search-icon"
            ></img> */}
            {/* <input
              onKeyUp={(e) => {
                if (e.key === "Enter") {
                  setFilter((prev) => {
                    let updatedFilter = { ...prev };
                    if (searchField === "") {
                      updatedFilter = { ...updatedFilter, filter: {} };
                      return updatedFilter;
                    }
                    updatedFilter = {
                      ...updatedFilter,
                      filter: {
                        ...updatedFilter.filter,
                        search: searchField,
                      },
                    };
                    return updatedFilter;
                  });
                }
              }}
              onChange={(e) => setSearchField(e.target.value.trim())}
              className=" w-60 rounded bg-[#E5F6FF] py-1 pl-10"
              placeholder="Search"
              type="search"
            /> */}
            <div>
              <Link
                to={`/admin/announcement/add`}
                className="flex items-center justify-center gap-2 rounded-sm bg-[#0098DA] px-4 py-2 text-base font-bold text-white"
              >
                <img
                  src={plusIcon}
                  className="my-auto inline"
                  alt="plus-icon"
                ></img>
                Announcement
              </Link>
            </div>
          </div>
        </div>
        <div>
          {announcementData && announcementData.length > 0 ? (
            <DataTable columns={columns} tableData={announcementData} />
          ) : (
            <div className="flex min-h-[80vh] items-center justify-center text-4xl	font-bold	">
              {!loading ? "No Announcement Found" : ""}
            </div>
          )}
        </div>
        <ReactPaginate
          className="pagination"
          previousLabel={"<<"}
          nextLabel={">>"}
          breakLabel={"..."}
          pageCount={Math.ceil(totalCount / filter.limit)}
          marginPagesDisplayed={1}
          pageRangeDisplayed={3}
          onPageChange={onPageChange}
          containerClassName={"pagination"}
          activeClassName={"active"}
          pageClassName={"page"}
          previousClassName={"previous"}
          nextClassName={"next"}
          breakClassName={"break"}
          disabledClassName={"disabled"}
        />
      </div>
      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        contentLabel="Confirm Deletion"
        className="modal"
        overlayClassName="overlay"
      >
        <h2>Are you sure you want to delete this Announcement?</h2>
        <div className="modal-buttons">
          <button onClick={handleDelete} className="confirm-button">
            Yes
          </button>
          <button onClick={closeModal} className="cancel-button">
            No
          </button>
        </div>
      </Modal>
    </>
  );
};

export default Announcement;
